import React, { useEffect } from "react";
import { useCourseTask } from "../hooks/useCourseTask";

export const OpenBookContext = React.createContext();
export const OpenBookScope = (props) => {
  const {
    data,
    isError,
    isLoading,
    iframeRef,
    selectedText,
    setSelectedText,
    afterTaskComplete,
    openErrMsgDialog,
    setOpenErrMsgDialog,
    openBookState,
    setOpenBookState,
    validateLoading
  } = useCourseTask();


  useEffect(() => {
    const validEnvironments = ["production"];
    const currentEnvironment = process.env.REACT_APP_ENVIRONMENT_KEY;
    if (validEnvironments.includes(currentEnvironment)) {
      (function (c, l, a, r, i, t, y) {
        c[a] =
          c[a] ||
          function () {
            (c[a].q = c[a].q || []).push(arguments);
          };
        t = l.createElement(r);
        t.async = true;
        t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
      })(window, document, "clarity", "script", "p7i9hojl6o");
    }
  }, []);

  useEffect(() => {
    if (!isLoading && !isError && data?.data?.answerkey?.data) {
      setOpenBookState((draft) => {
        const { question, analysis, conclusions } =
          data.data.answerkey.data;
        const { characterLimit, provisionsCount } =
          data.data.answerkey.frontend_Validation;
        draft.qn = { question, analysis, conclusions };
        draft.maxCharLimit = characterLimit;
        draft.provisionsCount = provisionsCount;
        if (!!data?.data?.title) {
          draft.taskTitle = data?.data?.title;
        }
        if (!!data?.data?.answerkey?.data?.taskName) {
          draft.taskName = data?.data?.answerkey?.data?.taskName;
        }
      });
    }
  }, [isLoading, isError, data?.data, setOpenBookState]);

  return (
    <OpenBookContext.Provider
      value={{
        openBookState,
        setOpenBookState,
        iframeRef,
        selectedText,
        setSelectedText,
        afterTaskComplete,
        openErrMsgDialog,
        setOpenErrMsgDialog,
        validateLoading
      }}
    >
      {isLoading && (
        <div className="spinner-container">
          <div className="spinner-border" role="status"></div>
        </div>
      )}
      {!isLoading && data?.status !== 200 && (
        <div className="no-data-container">
          <h1>No Data Found</h1>
          <p>We couldn't find any data to display. Please try again later.</p>
        </div>
      )}
      {!isLoading && data?.status === 200 && props.children}
    </OpenBookContext.Provider>
  );
};
